import { cn } from '@lib/util/cn';
import { TOPBAR_ITEMS } from '../../templates/nav/topbar-items';

const REVERSED_ITEMS = [...TOPBAR_ITEMS].reverse();

const TrustIndicators = () => (
  <div className="px-4 py-3 bg-moss-25 shrink-0">
    {REVERSED_ITEMS.map((item, index) => (
      <div
        key={item.label}
        className={cn(
          'flex items-center gap-3 py-3.5 text-sm text-fg-neutral-strong',
          index !== TOPBAR_ITEMS.length - 1 &&
            'border-b border-brand-neutral-200',
        )}
      >
        <span className="text-fg-neutral-subtle shrink-0">{item.icon}</span>
        {item.label}
      </div>
    ))}
  </div>
);

export default TrustIndicators;
